import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import styles from './cssModules/index.module.css';
import inactivity from './gallary/inactivity.png';


export default function DesignerDashboard({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    // const [month, setMonth] = useState(null);
    // const [year, setYear] = useState(null);
    const navigate = useNavigate();
    const [form, setForm] = useState({});

    const [tItemSold, setTItemSold] = useState(null);
    const [tGrossRev, setTGrossRev] = useState(null);
    const [totalPFC, setPFC] = useState(null);
    const [rawMaterialCost, setProductionCost] = useState(null);
    const [totalGst, setTotalGST] = useState(null);
    const [revAfterCommission, setRevAfterCommission] = useState(null);

    const [pageno, setPageno] = useState(1);
    const [noOfObs, setNoOfObs] = useState(null);
    const [prodLs, setProdLs] = useState(null);

    const renderCount = useRef(0);
    let jToken = localStorage.getItem('token');
    
    const monthVal = {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
    }

    const yearVal = Array.from({ length: 10 }, (_, index) => index + 2025);

    // Initial fetch
    useEffect(() => {
        const initFetch = async () => {
            try {
                const response = await fetch(`${apiURL}/api/dashboard`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: 'include'
                })

                if (response.status === 500) {
                    throw new Error('Error while fetching seller dashboard page');
                } else {
                    if (response.status !== 200) {
                        await loginStatus();
                        navigate('/login');
                    }
                }
                
            } catch (error) {
                navigate('/error');
                console.log('Error while fetching seller dashboard');
            }
        }
        initFetch();
    }, [jToken, loginStatus, apiURL, navigate])

    async function handleSubmit(event) {
        event.preventDefault();
        try {
            const formdata = new FormData(event.target);
            const formObject = {};
            formdata.forEach((value, key) => {
                formObject[key] = value
            });
            setForm(formObject);
            setPageno(1);
            const response = await fetch(`${apiURL}/api/dashboard`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'key': 'form',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    filterData: formObject,
                    pageNo: 1
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error while fetching seller dashboard')
            } else {
                if (response.status === 200) {
                    const res = await response.json();
                    const db_input = res.DBinput;
                    let totalItemSold = db_input.total_item_sold !== 0 ? db_input.total_item_sold : 0;
                    let totalRev = db_input.total_gross_rev ? db_input.total_gross_rev : 0;
                    let totalplatformCommission = totalRev * 0.07;
                    let totalProductionCost = totalItemSold * 300;
                    let totalgst = totalRev * 0.05;
                    let netRev = totalRev - totalplatformCommission - totalgst - totalProductionCost;
                    setTItemSold(totalItemSold);
                    setTGrossRev(totalRev);
                    setPFC(totalplatformCommission);
                    
                    // setProductionCost(db_input.total_delivery_cost ? db_input.total_delivery_cost * 1.18 : 0);
                    setProductionCost(totalProductionCost);
                    setTotalGST(totalgst);
                    
                    setRevAfterCommission(netRev);


                    setNoOfObs(res.noObs);
                    setProdLs(res.prod);
                    renderCount.current += 1;
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            }
        } catch (error) {
            navigate('/error');
            console.log(error.message);
        }
    }

    const changePage = async (event, ind) => {
        event.preventDefault();
        try {
            const increment = !ind ? 1 : -1;
            const response = await fetch(`${apiURL}/api/dashboard`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'key': 'page',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    filterData: form,
                    pageNo: pageno + increment
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error while changing the page');
            } else {

                if (response.status === 200) {
                    const res = await response.json();
                    setNoOfObs(res.noObs);
                    setProdLs(res.prod);
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            }
        } catch (error) {
            // await loginStatus();
            navigate('/error');
            console.log(error.message);
        }
    }

    return (
        <>
            <div className={`${styles.sellerDashboard}`}>
                {/* <span className={`${styles.sellerDBSPAN}`}>{'check: '.toUpperCase()}</span> */}
                <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontSize: '20px', fontWeight: '700', letterSpacing: '1px' }}>Check your business overview here by date</span>
                    <form id='selectDate' onSubmit={handleSubmit} className={`${styles.sellerDBForm}`}>
                        <div className={`${styles.sellerDBSelectionDiv}`}>
                            <select name='month' form="selectDate" className={`${styles.sellerDBformSelect}`}>
                                {Object.entries(monthVal).map((elem) => {
                                    return (
                                        <>
                                            <option value={elem[0]} key={elem}>{elem[1]}</option>
                                        </>
                                    )
                                })}
                            </select>
                            <select name='year' form="selectDate" className={`${styles.sellerDBformSelect}`}>
                                {yearVal.map((elem) => {
                                    return (
                                        <>
                                            <option value={elem} key={elem}>{elem}</option>
                                        </>
                                    )
                                })}
                            </select>
                        </div>
                        <input type="submit" value='CHECK' className={`${styles.sellerDBforminput}`} />
                    </form>
                </div>
            </div>
            {
                (parseInt(tItemSold) === 0) && (renderCount.current > 0) ?
                    (<>
                        <div className={`${styles.noNotificationDivSelect}`}>
                            <span className={`${styles.noNotificationSpan}`}>
                                No activity
                            </span>
                            <img src={inactivity} alt='Inactivity' style={{ height: '60px' }} />
                        </div>
                    </>) :
                    (
                        <>
                            <div className={`${styles.sellerDBMetricsDIV}`} style={parseInt(tItemSold) === 0 ? { display: 'none' } : {}}>
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span className={`${styles.sellerDBHeader}`}>{'Total item sold'.toUpperCase()}</span>
                                    <div>
                                        <span className={`${styles.sellerDBNumber}`}>{tItemSold ? tItemSold : ''}</span>
                                    </div>
                                </div>
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span className={`${styles.sellerDBHeader}`}>{'Total gross revenue'.toUpperCase()}</span>
                                    <div>
                                        <span className={`${styles.sellerDBNumber}`}>{tGrossRev ? Math.round(tGrossRev) : ''} INR</span>
                                    </div>
                                </div>
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span className={`${styles.sellerDBHeader}`}>{'Total Production Cost'.toUpperCase()}</span>
                                    <div>
                                        <span className={`${styles.sellerDBNumber}`}>{rawMaterialCost ? Math.round(rawMaterialCost) : ''} INR</span>
                                    </div>
                                </div>
                                {/* <div className={`${styles.sellerDBMEtric}`}>
                                <span className={`${styles.sellerDBHeader}`}>{'Revenue after delivery & before commission'.toUpperCase()}</span>
                                <div>
                                    <span className={`${styles.sellerDBNumber}`}>{tGrossRev ? tGrossRev - deliveryCost : ''} INR</span>
                                </div>
                            </div> */}
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span className={`${styles.sellerDBHeader}`}>{'Total platform Commission'.toUpperCase()}</span>
                                    <div>
                                        <span className={`${styles.sellerDBNumber}`}>{totalPFC ? Math.round(totalPFC) : ''} INR</span>
                                    </div>
                                </div>
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span className={`${styles.sellerDBHeader}`}>{'Total gst'.toUpperCase()}</span>
                                    <div>
                                        <span className={`${styles.sellerDBNumber}`}>{totalGst ? Math.round(totalGst) : ''} INR</span>
                                    </div>
                                </div>
                                {/* <div className={`${styles.sellerDBMEtric}`}>
                                    <span className={`${styles.sellerDBHeader}`}>{'Total returned delivery cost'.toUpperCase()}</span>
                                    <div>
                                        <span className={`${styles.sellerDBNumber}`}>{RdeliveryCost ? Math.round(RdeliveryCost) : ''} INR</span>
                                    </div>
                                </div> */}
                                {/* <div>Total cost for returned items</div> */}
                                <div className={`${styles.sellerDBMEtric}`}>
                                    <span className={`${styles.sellerDBHeader}`}>{'Net revenue'.toUpperCase()}</span>
                                    <div>
                                        <span className={`${styles.sellerDBNumber}`}>{revAfterCommission ? Math.round(revAfterCommission) : ''} INR</span>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className={`${styles.sellerDBPRODLS}`}>
                                    {prodLs && prodLs.map((item, index) => {
                                        return (
                                            <div className={`${styles.sellerDashboardprodDiv}`}>
                                                <div>
                                                    <img className={`${styles.sellerDBPRODIMG}`} id={index} src={`${apiURL}/images/${item.photo1}`} alt={index}></img>
                                                </div>
                                                <span className={`${styles.sellerDashboardStatusProd}`}
                                                    style={item.statusR === 'Y' ? { color: 'red' } : item.accepted === 'Y' ? { color: 'orange' } : { color: 'green' }}>
                                                    {item.statusR === 'Y' ? 'RETURNED' : item.accepted === 'Y' ? 'RETURN REQUESTED' : 'SOLD'}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div style={noOfObs < 10 ? { display: 'none' } : { display: 'block' }}>
                                    <button onClick={(e) => { changePage(e, true); setPageno(pageno - 1) }} style={pageno < 2 ? { display: 'none' } : { display: 'block' }}>Prev</button>
                                    <span>{pageno}</span>
                                    <button onClick={(e) => { changePage(e, false); setPageno(pageno + 1) }} >Next</button>
                                </div>
                            </div>
                        </>
                    )}
        </>
    )
}